export const downloadDoc = (url: string | undefined): void => {
    const a = document.createElement('a');
    if (url) {
        a.href = url;
        a.download = "file";
        a.click();
        a.remove();
    }
}